import Icon from '../Icon';
import {familyClasses, kindInfo} from '../../lib/kinds';
import {Kind} from '../../types';

// The kind's icon on its family's soft tile (DESIGN.md rule 5). Radius is about 30% of the size.
type Props = {kind: Kind; size?: number; className?: string};

export default function KindTile({kind, size = 36, className = ''}: Props) {
    const info = kindInfo(kind);
    return (
        <span
            className={`flex shrink-0 items-center justify-center ${familyClasses(info.family)} ${className}`}
            style={{width: size, height: size, borderRadius: Math.round(size * 0.3)}}
        >
            <Icon name={info.icon} size={Math.round(size * 0.55)} />
        </span>
    );
}
